import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

// CERRAR SESIÓN, UNA SOLA VEZ (10-10). Salir de la cuenta son siempre los mismos tres
// gestos: `logout()` del contexto, a la pantalla de entrar y el aviso. Vive aquí para las
// pantallas que van FUERA del menú (el cuestionario inicial y Planes), desde las que no
// había ninguna forma de salir: quien entraba con la cuenta equivocada se quedaba encerrado
// en el cuestionario. «Mi perfil» usa el mismo gesto.
//
// `antesDeSalir` (24-10): lo que la pantalla tenga que guardar mientras todavía hay sesión.
// El cuestionario guarda ahí en qué pantalla va y lo que lleva elegido, para que al volver
// a entrar siga donde lo dejó. Si falla, se sale igual: no se encierra a nadie por un error.
export const useCerrarSesion = (antesDeSalir) => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    return async () => {
        if (antesDeSalir) {
            try { await antesDeSalir(); } catch (e) { console.error('[cerrar sesión] no se guardó lo de antes', e); }
        }
        logout();
        navigate('/auth');
        toast.success('Sesión cerrada');
    };
};

// La salida discreta: un enlace pequeño, sin color hasta que se pasa por encima (el mismo
// rojo de «Cerrar sesión» de Mi perfil). No compite con lo que la pantalla pide hacer.
const CerrarSesion = ({ className = '', antesDeSalir }) => {
    const cerrarSesion = useCerrarSesion(antesDeSalir);
    return (
        <button type="button" onClick={cerrarSesion} data-testid="cerrar-sesion"
            className={`inline-flex items-center gap-1.5 text-xs text-foreground/40 hover:text-red-500 transition-colors ${className}`}>
            <LogOut className="w-3.5 h-3.5" /> Cerrar sesión
        </button>
    );
};

export default CerrarSesion;
